/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseApiClient } from '../base-api-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { AdvertisementModel } from '../models/advertisement-model';

@Injectable({ providedIn: 'root' })
export class AdvertisementsApiClient extends BaseApiClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllAdvertisements()` */
  static readonly GetAllAdvertisementsPath = '/api/v1/advertisements/{countryCode}/{languageCode}';

  /**
   * Get all localized advertisements.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllAdvertisements$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAdvertisements$Plain$Response(
    params: {
      countryCode: string;
      languageCode: string;
      platform?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<AdvertisementModel>>> {
    const rb = new RequestBuilder(this.rootUrl, AdvertisementsApiClient.GetAllAdvertisementsPath, 'get');
    if (params) {
      rb.path('countryCode', params.countryCode, {});
      rb.path('languageCode', params.languageCode, {});
      rb.query('platform', params.platform, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AdvertisementModel>>;
      })
    );
  }

  /**
   * Get all localized advertisements.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllAdvertisements$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAdvertisements$Plain(
    params: {
      countryCode: string;
      languageCode: string;
      platform?: string;
    },
    context?: HttpContext
  ): Observable<Array<AdvertisementModel>> {
    return this.getAllAdvertisements$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AdvertisementModel>>): Array<AdvertisementModel> => r.body)
    );
  }

  /**
   * Get all localized advertisements.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllAdvertisements()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAdvertisements$Response(
    params: {
      countryCode: string;
      languageCode: string;
      platform?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<AdvertisementModel>>> {
    const rb = new RequestBuilder(this.rootUrl, AdvertisementsApiClient.GetAllAdvertisementsPath, 'get');
    if (params) {
      rb.path('countryCode', params.countryCode, {});
      rb.path('languageCode', params.languageCode, {});
      rb.query('platform', params.platform, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AdvertisementModel>>;
      })
    );
  }

  /**
   * Get all localized advertisements.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllAdvertisements$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAdvertisements(
    params: {
      countryCode: string;
      languageCode: string;
      platform?: string;
    },
    context?: HttpContext
  ): Observable<Array<AdvertisementModel>> {
    return this.getAllAdvertisements$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AdvertisementModel>>): Array<AdvertisementModel> => r.body)
    );
  }

}
